export const BOOTSTRAP_SUPPLIERS = 'BOOTSTRAP_SUPPLIERS'
export const SET_SELECTED_SUPPLIERS = 'SET_SELECTED_SUPPLIERS'
export const SET_TOTAL_SUPPLIERS = 'SET_TOTAL_SUPPLIERS'
export const RESET_SELECTED_SUPPLIER = 'RESET_SELECTED_SUPPLIER'
export const SET_SELECT_ALL_STATE = 'SET_SELECT_ALL_STATE'
export const VIEW_SUPPLIER ='VIEW_SUPPLIER'
export const ADD_SUPPLIER = 'ADD_SUPPLIER'